import React from "react"
import styled from "styled-components"

import { fontWhite, mainGreen, fontBlue } from "../../styles/index"
import FloraLogo from "../../images/Flora-Light.svg"
import PTAnd from "../../images/pt-assets/pt-and.png"

const HeaderContent = () => {
  return (
    <Wrapper>
      <div className="row mb-5">
        <div className="col-lg-6 ml-2">
          <img src={PTAnd} alt="Prime Trust and Flora" />
          <img src={FloraLogo} alt="Flora logo" />
        </div>
      </div>
      <div className="row d-flex justify-content-around">
        <div className="col-lg-5">
          <h1>Invest in early and growth stage opportunities</h1>
          <h5>
            Using a Prime IRA from Prime Trust, your retirement account can help
            you get into the next big startup
          </h5>
          <div className="desktop-btn-row">
            <button className="green-btn">
              <a
                href="https://my.primetrust.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                Open a Prime IRA
              </a>
            </button>
            <button className="white-btn">
              <a href="mailto:ira@primetrust.com">Contact Us</a>
            </button>
          </div>
        </div>
        <div className="col-lg-6">
          <iframe
            src="https://player.vimeo.com/video/415974466"
            width="700"
            height="360"
            frameBorder="0"
            allow="autoplay; fullscreen"
            allowFullScreen
            SameSite
            title="What is Prime Trust"
          ></iframe>
        </div>
      </div>
      <div className="row justify-content-center mobile-btn-row">
        <div className="col-md-6 text-center">
          <button className="green-btn">
            <a
              href="https://my.primetrust.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              Open a Prime IRA
            </a>
          </button>
          <button className="white-btn">
            <a href="mailto:ira@primetrust.com">Contact Us</a>
          </button>
        </div>
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.div`
.mobile-btn-row{
  display: none;
}
  padding: 3rem 0 5rem 0;
  /* a {
    color: ${fontBlue};
  } */
  h1, a {
    color: ${fontWhite};
    text-decoration: none;

  }
  h5 {
    margin: 2rem 0 3rem 0;
    color: ${fontWhite};
  }

  .col-lg-6 {
    flex: 0 0 52%;
    max-width: 52%;
  }

  button.green-btn {
    margin: 1rem 1rem;
    background-color: ${mainGreen};
    color: ${fontWhite};
    font-style: bold;
    padding: 1rem 2.5rem;
    border: none;
    border-radius: 8px;
    font-size: 20px;
  }

  button.white-btn {
    margin: 1rem 1rem;
    background-color: white;
    color: ${fontBlue};
    padding: 1rem 2.5rem;
    border: none;
    border-radius: 8px;
    font-size: 20px;
    a {
      color: ${fontBlue};
    }
  }

  img {
    height: 75px;
  }

  @media screen and (max-width: 870px) {
    .mobile-btn-row {
      display: block;
    }

    .desktop-btn-row {
      display: none;
    }

    h1 {
      font-size: 40pt !important;
    }
    iframe {
      width: 325px;
      margin: 2rem 0;
    }
    .col-lg-6 {
      max-width: 100%;
    }
  }
`

export default HeaderContent
